var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78109 7.04163C9.08024 7.04163 9.32275 6.79911 9.32275 6.49996C9.32275 6.2008 9.08024 5.95829 8.78109 5.95829H6.88525V2.97913C6.88525 2.67997 6.64274 2.43746 6.34359 2.43746C6.04443 2.43746 5.80192 2.67997 5.80192 2.97913V6.49996C5.80192 6.79911 6.04443 7.04163 6.34359 7.04163H8.78109Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34359 0.541626C3.05289 0.541626 0.385254 3.20926 0.385254 6.49996C0.385254 9.79066 3.05289 12.4583 6.34359 12.4583C9.63428 12.4583 12.3019 9.79066 12.3019 6.49996C12.3019 3.20926 9.63428 0.541626 6.34359 0.541626ZM1.46859 6.49996C1.46859 3.80757 3.6512 1.62496 6.34359 1.62496C9.03597 1.62496 11.2186 3.80757 11.2186 6.49996C11.2186 9.19235 9.03597 11.375 6.34359 11.375C3.6512 11.375 1.46859 9.19235 1.46859 6.49996Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.5f9b49897502a53d95963625b27e9c00.svg";
export { ForwardRef as ReactComponent };